import React, { useEffect, useState } from "react"
// import "../../../../assets/css/Staff/Staff.css"
// import "../../../../assets/css/Credential/Credential.css"
// import "../../../../assets/css/Scollbar.css"
// import "../../../../assets/css/Work/projects.css"
// import "../../../../assets/css/Settings/generalSetting.css"

import {
  Container,
  Row,
  Col,
} from "reactstrap"
import Loader from "pages/Separate/Loader"
import CalendarAccessTab from "./CalenderAccessTab.js"

const CalenderAccessIndex = ({ verticalActiveTabs }) => {
  const [isCollapse, setIsCollapse] = useState(true)
  const [isLoading, setLoading] = useState(false)
  document.title = "General Task Setting | Zithas Crm"

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className=" mb-4">
        <Container fluid>
          <div id="credentialPage">
            <Row
              className={`justify-content-between di-flex align-items-top `}
              id="cred"
            >
              <Col
                md={isCollapse ? "12" : "11"}
                className={`z-1 pe-0  ${isCollapse && "width-100 ps-0"}`}
              >
                <div className="card p-0 mb-0 h-100">
                    <CalendarAccessTab />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CalenderAccessIndex
